import doIt from '../images/portfolio/DOIT.png';
import social from '../images/portfolio/social.png';
import quote from '../images/portfolio/quote.png';
import song from '../images/portfolio/song.png';

const PortfolioData = [
    {
        image: song,
        title: "Listen songs",
        text: "Allows you to immerse in the captivating rhythms of the top music around you. It further provides an avenue for you to explore and appreciate celebrated artists, whilst keeping you updated on the trending songs.",
        pUrl: "https://enchanting-fairy-1e6bcf.netlify.app/"
    },
    {
        image: social,
        title: "Get Social",
        text: "This project centers on a vibrant social platform designed to empower you to showcase your artistic endeavors and professional work to a diverse audience. It not only amplifies your visibility but also fosters a sense of community by enabling you to connect with like-minded individuals.",
        pUrl: "https://curious-heliotrope-f99e48.netlify.app/"
    },
    {
        image: doIt,
        title: "DO.IT",
        text: "A multifunctional Todo App, specifically crafted to put you at the forefront of your day and enhance your productivity. It features a variety of templates, providing a customizable approach to managing your tasks.",
        pUrl: "https://glowing-kheer-c43c78.netlify.app/"
    },
    {
        image: quote,
        title: "My Quotes",
        text: "A unique platform designed for you to disseminate your quotes. It provides an avenue for self-expression and intellectual sharing, allowing your thoughts, wisdom, and inspiration to resonate with a wider audience.",
        pUrl: "https://melodious-platypus-8b518a.netlify.app/"
    },
]

export default PortfolioData;